import { gql } from '@apollo/client';

const getStoreSearchQuery = () => {
  const query = `
    query StoreSearch($zipCode: String!, $limit: Int, $radius: Float!) {
      storeSearch(zipCode: $zipCode, limit: $limit, radius: $radius) {
        storeId
        storeName
        phone
        distance
        address {
          street
          city
          state
          country
          postalCode
        }
        __typename
      }
    }
  `;

  return gql(query);
};

export default getStoreSearchQuery;
